
import { Component, Mixins } from "vue-property-decorator";
import SecuritySettingsMixin from "@/mixins/Security/SecuritySettingsMixin";

@Component
export default class NavigationDrawerListGroupCommodity extends Mixins(
  SecuritySettingsMixin
) {}
